import { PageParams, PageParamsAsString } from "../entities/interfaces/misc";
import { Discount } from "../entities/interfaces/order";

export function isPhoneNumber(input: string): boolean {
  const trimmed = input.trim();

  // Simple phone number pattern: digits with optional +, spaces, dashes, or parentheses
  const phonePattern = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?){1,2}\d{3,4}$/;

  // If it matches the phone number pattern, return "phone"
  if (phonePattern.test(trimmed)) {
    return true;
  } else return false;
}

export const calculateDiscountAmtFromBill = (discountArr: Discount[]) => {
  return discountArr.reduce((acc, curr) => {
    return (acc += curr.value);
  }, 0);
};

export function stringifyPageParams(params: PageParams): PageParamsAsString {
  return {
    page: String(params.page),
    perPage: String(params.perPage),
  };
}

export const saveAsFile = (
  blobData: any,
  filename: string,
  fileType: string
) => {
  const blob = new Blob([blobData], { type: fileType });
  const url = window.URL.createObjectURL(blob);

  // Create a temporary download link
  const a = document.createElement("a");
  a.href = url;
  a.download = filename; // Suggested filename
  document.body.appendChild(a);

  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
